import React, { useState } from 'react';
import { useMutation } from '@apollo/client/react';
import moment from 'moment';
import Button from 'react-bootstrap/Button';
import TextContent from '../_common/TextContent';
import JobDetail from './JobDetail';
import { DISABLE_JOB } from '../../graphql/client/mutations';
import { GET_JOB_PROFILE } from '../../graphql/client/queries';
import {
    DisableJob,
    GetFullJobProfile_getJobProfile as JobProfileData,
    GetFullJobProfile,
    GetFullJobProfile_getJobProfile_pumpScheduleSummary as PumpScheduleSummaryData,
} from '../../types/schemaTypes';
import { Query } from '../_common';
import { Error, Loading } from '../_common';
import JobProfileNav from './JobProfileNav';
import './JobProfile.scss';
import { Routes } from '../../utils';
import JobSummary from './JobSummary';
import JobTotals from './JobTotals';
import CustomerDetail from './CustomerDetail';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import DeleteModal from './DeleteModal';
import ErrorModal from './ErrorModal';
import { useAuthContext } from '../Auth/AuthProvider';
import { PermissionEnum } from '../../types/PermissionEnum';
import { useParams } from 'react-router-dom';
import { JobStatusEnum } from '../../types/JobStatusEnum';
import Switch from "react-switch";
import JobMenuItems from '../Header/JobMenuItemsHeader/JobMenuItems';

const JobProfile = ({ match }: any): React.ReactElement => {
    const authContext = useAuthContext();
    let jobIdVal: any = ''
    const { jobId } = useParams();
    jobIdVal = jobId
    const variables = {
        jobId: parseInt(jobIdVal),
    };
    const [tabTitle, setTabTitle] = useState(document.title);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [mutationDataState, setMutationDataState] = useState(false);
    const displayJobs = (): void => {
        const URL = `${window.location.origin}${Routes.JOB_MANAGEMENT.route}`;
        window.open(URL, '_self');
    };

    const [disableJob, { data: mutationData }] = useMutation<DisableJob>(DISABLE_JOB, {
        onCompleted: () => {
            setMutationDataState(true);
        },
        onError: () => {
            setShowErrorModal(true);
        },
    });

    const editJob = (): void => {
        const URL = `${window.location.origin}${Routes.EDIT_JOB.route}`;
        window.open(URL + jobIdVal, '_self');
    };
    const formatDate = (text: string | null): string => (text ? moment(text).format('MMM DD, YYYY') : '');

    const deleteJob = (): void => {
        setShowDeleteModal(true);
    };

        const handleToggleChange=(checked) =>{
            console.log(checked);
        };

    const onConfirmDelete = async (): Promise<void> => {
        disableJob({
            variables: {
                input: {
                    jobId: variables.jobId,
                },
            },
        });
        setShowDeleteModal(false);
    };

    const OverlayDiv: any = () => <div className="JobProfile-DeleteIcon-Tooltip">Delete Job</div>;
    const isDeleteJobEnabled = authContext.userHasPermission(PermissionEnum.DeleteJob);
    const isEditJobEnabled = authContext.userHasPermission(PermissionEnum.EditJob);
    const isDisplayLoadsEnabled = authContext.userHasPermission(PermissionEnum.ViewLoads);

    return (
        <Query<GetFullJobProfile> query={GET_JOB_PROFILE} variables={variables} fetchPolicy="cache-and-network">
            {({ loading, error, data }): React.ReactElement | null => {

                let jobProfileData: JobProfileData | null;

                React.useEffect(() => {
                    if (data?.getJobProfile) {
                        const profile = data.getJobProfile as JobProfileData;
                        const { jobDetails } = profile;

                        document.title = jobDetails?.jobName ?? tabTitle;
                        localStorage.setItem('Jobdetails-TabName', document.title);
                        setTabTitle(document.title);
                    }
                }, [data, data?.getJobProfile, tabTitle])

                if (loading) {
                    return <Loading />;
                }

                if (error) {
                    return <Error error={error} />;
                }

                if (data?.getJobProfile) {
                    const profile = data.getJobProfile as JobProfileData;
                    jobProfileData = profile;

                    const { customerDetails, jobDetails, pumpScheduleSummary, totalBoxesForWells } = profile;
                    const customerId = customerDetails && customerDetails.customerId ? customerDetails.customerId : 0;

                    const pumpScheduleSummaryList: PumpScheduleSummaryData[] = [];
                    if (pumpScheduleSummary !== null && pumpScheduleSummary.length !== 0) {
                        pumpScheduleSummary.forEach((item: PumpScheduleSummaryData | null): void => {
                            if (item !== null) {
                                pumpScheduleSummaryList.push(item);
                            }
                        });
                    }

                    const jobDetailComponent = jobDetails ? (
                        <JobDetail
                            addressLine1={jobDetails.addressLine1}
                            addressLine2={jobDetails.addressLine2}
                            city={jobDetails.city}
                            district={jobDetails!.district}
                            latitude={jobDetails.latitude}
                            longitude={jobDetails.longitude}
                            region={jobDetails!.region}
                            state={jobDetails.state}
                            zip={jobDetails.zip}
                            directions={jobDetails.directions}
                        />
                    ) : (
                        <JobDetail />
                    );

                    const customerDetailComponent =
                        customerDetails !== null ? (
                            <CustomerDetail
                                customerName={customerDetails.customerName}
                                customerPo={customerDetails.customerPO}
                                epCompany={customerDetails.epCompany}
                                crew={customerDetails.crew}
                                contact={customerDetails.contact}
                                phoneNumber={customerDetails.phoneNumber}
                            />
                        ) : (
                            <CustomerDetail />
                        );
                    if (
                        (mutationData?.disableJob?.errors?.length ?? 0) !== 0 &&
                        mutationDataState
                    ) {
                        setShowErrorModal(true);
                    }

                    if (
                        (mutationData?.disableJob?.errors?.length ?? -1) === 0 &&
                        mutationDataState
                    ) {
                        displayJobs();
                    }
                        
                    return (
                        <div className="JobProfile-Container">
                            <DeleteModal
                                show={showDeleteModal}
                                onCancel={() => {
                                    setShowDeleteModal(false);
                                }}
                                onConfirm={onConfirmDelete}
                                name="job"
                            />



                            <ErrorModal
                                show={showErrorModal}
                                onCancel={() => {
                                    setShowErrorModal(false);
                                    setMutationDataState(false);
                                }}
                            />

                            <div className="JobProfile-Header">
                                <div className="JobProfile-HeaderTitle">
                                    {isDeleteJobEnabled && (
                                        <OverlayTrigger
                                            placement="bottom"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={OverlayDiv}
                                        >
                                            <div className="JobProfile-IconBackground" onClick={deleteJob}>
                                                <i className="material-icons JobProfile-DeleteIcon">delete</i>
                                            </div>
                                        </OverlayTrigger>
                                    )}
                                    Job Profile
                                </div>

                                <JobMenuItems jobId={jobId ?? '0'} menu='jobDetails' />
                            </div>

                            <div className="JobProfile-JobDetailsContainer">
                                <div className="JobProfile-JobNameContainer">
                                    {/* {jobDetails!.status!.status === JobStatusEnum.COMPLETED.toString() ? (
                                        <div className="JobProfile-NameEditContainer">
                                            <div className="JobProfile-JobName">{jobDetails!.jobName || ''}</div>
                                        </div>
                                    ) : ( */}
                                    <div className="JobProfile-NameEditContainer">
                                        <div className="JobProfile-JobName">{jobDetails!.jobName || ''}</div>
                                        <i className="material-icons JobProfile-EditIcon">edit</i>
                                        {isEditJobEnabled && (
                                            <Button
                                                className="JobProfile-Edit"
                                                variant="link"
                                                onClick={() => {
                                                    editJob();
                                                }}
                                            >
                                                Edit
                                            </Button>
                                        )}
                                    </div>
                                    {/* )} */}
                                    <div className="JobProfile-NameEditContainer">
                                        <TextContent title="Planned Start:" value={formatDate(jobDetails!.wellStartDate)} />
                                        <TextContent title="Planned End:" value={formatDate(jobDetails!.wellEndDate)} />
                                        <TextContent title="Actual Start:" value={formatDate(jobDetails!.actualStartDate)} />
                                        <TextContent title="Actual End:" value={formatDate(jobDetails!.actualEndDate)} />

                                        <div className="JobProfile-StatusContainer">
                                            <i className="material-icons">cached</i>
                                            <div className="JobProfile-StatusTitle">{jobDetails!.status!.status}</div>
                                        </div>
                                    </div>
                                </div>
                                <TextContent title="JDE #:" value={jobDetails!.jdeNumber || ''} />
                                {jobDetails?.isBellyDump && <div style={{height: '10px', paddingTop: '4px', pointerEvents: 'none'}}>
                                    <label>
                                        <Switch
                                            checked={jobDetails?.isBellyDump ? true : false}
                                            onChange={handleToggleChange}
                                            onColor="#b6bd00"
                                            onHandleColor="#f6f6f6"
                                            handleDiameter={24}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            boxShadow="0px 1px 5px rgba(162, 193, 83, 0.6)"
                                            activeBoxShadow="0px 0px 1px 10px rgba(165, 205, 71, 0.2)"
                                            height={20}
                                            width={48}
                                            className="react-switch"
                                            id="material-switch"
                                        />
                                        <span className='AddJob-BTB-Toggle-Class'>Belly to box</span>
                                    </label>
                                </div>}
                                <div className="JobProfile-JobDetails">
                                    {jobDetailComponent}
                                    {customerDetailComponent}
                                    <JobSummary jobId={variables.jobId} wellTotalBoxes={totalBoxesForWells || 0} />
                                    <JobTotals
                                        loadsByWell={
                                            pumpScheduleSummary
                                                ? pumpScheduleSummary.map(ps => ({
                                                    wellName: ps ? ps.wellName : '',
                                                    loadCount: ps ? ps.totalBoxes : 0,
                                                }))
                                                : []
                                        }
                                    />
                                </div>
                            </div>
                            <div className="JobProfile-Nav">
                                <JobProfileNav
                                    pumpScheduleSummary={pumpScheduleSummaryList}
                                    jobId={parseInt(jobIdVal)}
                                    region={jobDetails!.region}
                                    customerId={customerId}
                                    jobName={jobDetails!.jobName}
                                    isJobCompleted={jobDetails!.status!.status === JobStatusEnum.COMPLETED.toString()}
                                />
                            </div>
                        </div>
                    );
                } else {
                    return <div></div>; // TODO: Show empty data view
                }
            }}
        </Query>
    );
};

export default JobProfile;

